import React, { useState } from "react";
import {config, service, useFetchData, useTextarea} from "../utils";
import { ComponentRenderer, Radio, Button } from ".";
import isEmpty from "lodash/isEmpty";

const CancelBooking = ({
  width,
  breakpoint,
}) => {
  const {value, onChange} = useTextarea();
  const {response, status} = useFetchData(config.PAGE_ID.CANCEL_BOOKING);
  const [selected, setSelected] = useState(null);
  const [postApiState, setState] = useState({
    response: {},
    postStatus: config.STATUS.NS,
  });

  const handleClickOpt = item => {
    setSelected(item);
  };

  const getFeedback = () => {
    if (service.isTextQuestion(selected.id)) {
      return `${selected.text} - ${value}`;
    }
    return selected.text;
  }

  const handleClick = async () => {
    service.trackClick(config.NEED_HELP_TRACKING.NEED_HELP, config.CTA_TRACKING_ID.CANCEL_BOOKING);
    setState({
      ...postApiState,
      postStatus: config.STATUS.IP,
    });
    const res = await service.submit(config.PAGE_ID.CANCEL_BOOKING, {
      feedbackText: getFeedback(),
    });
    setState({
      ...postApiState,
      response: res,
      postStatus: config.STATUS.D
    });
  };

  const disableButton = () => {
    return (
      isEmpty(selected) ||
      (service.isTextQuestion(selected.id) && !service.trimTrailingSpaces(value)) ||
      postApiState.postStatus === config.STATUS.IP
    )
  };

  const {optionsTextList, bodyTextList, buttonText} = response;
  return (
    <ComponentRenderer status={status} response={response} postApiState={postApiState}>
      <React.Fragment>
        {optionsTextList && (
          <div>
            <p
              className={`${
                width > breakpoint
                  ? "font16 lineHeight22 appendBottom15"
                  : "font14 lineHeight16 appendBottom20"
                }`}
            >
              {bodyTextList.join(' ')}
            </p>
            {optionsTextList && optionsTextList.length &&
              optionsTextList.map((item) => {
                return (
                  <Radio
                    key={item.id}
                    item={item}
                    handleClickOpt={handleClickOpt}
                    selected={selected} />
                  );
              })
            }
            {
              !!(selected && service.isTextQuestion(selected.id)) &&
              <textarea
                value={value}
                onChange={onChange}
                placeholder={bodyTextList.join("")}
              />
            }
          </div>
        )}
        <Button
          onClick={handleClick}
          disable={disableButton()}
          label={buttonText}
        />
      </React.Fragment>
    </ComponentRenderer>
  )
}

export default CancelBooking;
